// @flow

import React, { Component, Fragment } from 'react';
import { Container, Col, Row } from 'reactstrap';

import OverviewJumbotron from './OverviewJumbotron';
import BasicInfo from './BasicInfo';
// import SideMenu from './SideMenu';
import TerrainInfo from './TerrainInfo';
import ItineraryOverview from './ItineraryOverview';
import FixDeparture from './FixDeparture';
import Highlights from './Highlights';
import Description from './Description';
import TrekOverviewModalContainer from '../TrekOverviewModalContainer';
import ReviewsRatings from '../../../redux/containers/ReviewsRatingsContainer';
import FAQ from './FAQ';

type Props = {
  trek: Object,
  ratings: Object,
  noOfReviews: number,
  pax: number,
};

type State = {
  isLightOpen: boolean,
  lightboxPhotoIndex: number,
};

const selfGuidedTrekRatingsTitles = ['Rating'];

const guidedTrekRatingsTitles = [
  'Communication',
  'Knowledge',
  'Organization Skills',
  'Fun Factor',
  'Safety',
];

class TrekOverview extends Component<Props, State> {
  state = {
    isLightOpen: false,
    lightboxPhotoIndex: 0,
  };

  render() {
    const { trek, noOfReviews, ratings } = this.props;

    const {
      name,
      highlights,
      itinerary,
      long_overview,
      terrain_information,
      quick_facts,
      elevation_profile,
      id,
      region,
      group_size,
      followers,
      is_guided,
      is_template,
      is_owner,
    } = trek;

    const basic_info = {
      minSize: group_size && group_size.minimum,
      maxSize: group_size && group_size.maximum,
      followers,
    };

    const ratingsTitles = is_guided ? guidedTrekRatingsTitles : selfGuidedTrekRatingsTitles;

    const DayToDayItinerary = (
      <ItineraryOverview
        itinerary={itinerary}
        trekName={name}
        trekId={id}
        region={region}
      />
    );

    const Departures = is_template && (
      <div id="fix-departures">
        <FixDeparture trekId={id} region={region} />
      </div>
    );

    const Desc = (
      <div className="white-panel">
        <Description description={long_overview} />
      </div>
    );

    const QuickFacts = (
      <TerrainInfo
        terrain_information={terrain_information}
        quick_facts={quick_facts}
        elevation_profile={elevation_profile}
        trekId={id}
      />
    );

    return (
      <Fragment>
        {/* <SideMenu /> */}
        <OverviewJumbotron
          toggleLightbox={this.toggleLightbox}
          {...trek}
          ratings={ratings}
          noOfReviews={noOfReviews}
        />
        <Container>
          <Row>
            <Col lg="6" md="6" sm="12">
              {is_guided && <BasicInfo data={basic_info} />}
              <div className="white-panel">
                <Highlights highlights={highlights} />
              </div>
              {QuickFacts}
              {DayToDayItinerary}
              {/* {Departures} */}
              
            </Col>
            <Col md="6" lg="6" id="allReviews">
              {Desc}
              <FAQ />
              <ReviewsRatings
                origin="treks"
                allowReview={!is_owner}
                ratingsTitles={ratingsTitles}
              />
            </Col>
          </Row>
        </Container>
        <TrekOverviewModalContainer />
      </Fragment>
    );
  }

  toggleLightbox = photoIndex => {
    if (!this.state.isLightOpen) {
      this.setState({
        isLightOpen: true,
        lightboxPhotoIndex: photoIndex ? photoIndex : 0,
      });
    } else {
      this.setState({
        isLightOpen: false,
      });
    }
  };
}

export default TrekOverview;



// WEBPACK FOOTER //
// ./src/components/TrekDetail/DayOverview/TrekOverview.jsx